import _objectSpread from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/esnext.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "app-page user"
};
var _hoisted_2 = {
  class: "left"
};
var _hoisted_3 = {
  class: "search-container"
};
import { TREE_URL } from '@/api/system/department';
import { remove } from '@/api/system/user';
import { createTableHeaderButton } from '@/component-create/utils/create-table-column';
import { SearchForm } from '@/component-create/SearchForm';
import { Table } from '@/component-create/Table';
import { deleteBox, toast } from '@/utils/message';
import { column, SearchItems } from './config';
import { renderAddForm } from './userAdd';
import { renderEditForm } from './userEdit';
import { renderPassword } from './userPassword';

import { ref, onMounted } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'User',
  setup: function setup(__props) {
    var searchForm = null;
    var table = null;
    var addForm = null;
    var editForm = null;
    var passwordForm = null;
    var searchFormRef = ref();
    var tableRef = ref();
    var addRef = ref();
    var editRef = ref();
    var passwordRef = ref();
    var deptIds = ref([]);
    onMounted(function () {
      renderForm();
      renderTable();
      // 绘制新增表单
      addForm = renderAddForm(addRef.value);
      addForm.onSaveSuccess = function () {
        var _table, _searchForm;
        (_table = table) === null || _table === void 0 || _table.load(_objectSpread(_objectSpread({}, (_searchForm = searchForm) === null || _searchForm === void 0 ? void 0 : _searchForm.getFormDataNotValidate()), {}, {
          deptIds: deptIds.value.join(',')
        }));
      };
      // 绘制编辑表单
      editForm = renderEditForm(editRef.value);
      editForm.onSaveSuccess = function () {
        var _table2, _searchForm2;
        (_table2 = table) === null || _table2 === void 0 || _table2.load(_objectSpread(_objectSpread({}, (_searchForm2 = searchForm) === null || _searchForm2 === void 0 ? void 0 : _searchForm2.getFormDataNotValidate()), {}, {
          deptIds: deptIds.value.join(',')
        }));
      };
      // 绘制密码修改表单
      passwordForm = renderPassword(passwordRef.value);
    });
    function checkChange(e, checked) {
      deptIds.value = (checked.checkedNodes || []).map(function (item) {
        return item.id;
      });
    }
    /**
     * 表格行编辑
     */
    function formItemEdit(row) {
      var _editForm;
      (_editForm = editForm) === null || _editForm === void 0 || _editForm.open(row.id);
    }
    /**
     * 表格行删除
     */
    function formItemDelete(row) {
      deleteBox().then(function () {
        remove([row.id]).then(function () {
          var _table3, _searchForm3;
          toast.success('删除成功');
          (_table3 = table) === null || _table3 === void 0 || _table3.load(_objectSpread(_objectSpread({}, (_searchForm3 = searchForm) === null || _searchForm3 === void 0 ? void 0 : _searchForm3.getFormDataNotValidate()), {}, {
            deptIds: deptIds.value.join(',')
          }));
        });
      });
    }
    /**
     * 表格头部按钮
     */
    var headerButtons = [createTableHeaderButton('新增', 'primary', 'Plus', function () {
      var _addForm;
      (_addForm = addForm) === null || _addForm === void 0 || _addForm.open();
    }), createTableHeaderButton('编辑', 'primary', 'Edit', function (selectRows) {
      var _editForm2;
      if (selectRows.length > 1) {
        toast.warn('只能操作一条数据');
        return false;
      }
      if (selectRows.length < 1) {
        toast.warn('请选择一条数据');
        return false;
      }
      (_editForm2 = editForm) === null || _editForm2 === void 0 || _editForm2.open(selectRows[0].id);
    }), createTableHeaderButton('删除', 'primary', 'Delete', function (selectRows) {
      deleteBox().then(function () {
        var ids = selectRows.map(function (item) {
          return item.id;
        });
        remove(ids).then(function () {
          var _table4, _searchForm4;
          toast.success('删除成功');
          (_table4 = table) === null || _table4 === void 0 || _table4.load(_objectSpread(_objectSpread({}, (_searchForm4 = searchForm) === null || _searchForm4 === void 0 ? void 0 : _searchForm4.getFormDataNotValidate()), {}, {
            deptIds: deptIds.value.join(',')
          }));
        });
      });
    }), createTableHeaderButton('修改密码', 'primary', 'Unlock', function (selectRows) {
      var _passwordForm;
      if (selectRows.length > 1) {
        toast.warn('只能操作一条数据');
        return false;
      }
      if (selectRows.length < 1) {
        toast.warn('请选择一条数据');
        return false;
      }
      passwordForm = renderPassword(passwordRef.value);
      (_passwordForm = passwordForm) === null || _passwordForm === void 0 || _passwordForm.open(selectRows[0].id);
    })];
    /**
     * 绘制搜索表单
     */
    function renderForm() {
      searchForm = new SearchForm(searchFormRef.value, SearchItems, {
        labelWidth: '80px'
      });
      searchForm.onSearch = function (formData) {
        var _table5;
        (_table5 = table) === null || _table5 === void 0 || _table5.load(_objectSpread(_objectSpread({}, formData), {}, {
          deptIds: deptIds.value.join(',')
        }));
      };
    }
    /**
     * 绘制表格
     */
    function renderTable() {
      table = new Table(tableRef.value, column(formItemEdit, formItemDelete), headerButtons, {
        border: true
      }, 'system/user/page');
    }
    return function (_ctx, _cache) {
      var _component_XSearchTree = _resolveComponent("XSearchTree");
      var _component_XFlexCtx = _resolveComponent("XFlexCtx");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_XSearchTree, {
        url: _unref(TREE_URL),
        label: function label(item) {
          return "".concat(item.departmentName, "(").concat(item.departmentCode, ")");
        },
        value: "departmentCode",
        onCheck: checkChange,
        "el-tree-prop": {
          showCheckbox: true,
          checkStrictly: true,
          nodeKey: 'id'
        }
      }, null, 8, ["url", "label"])]), _createVNode(_component_XFlexCtx, {
        flex: 1
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
            ref_key: "searchFormRef",
            ref: searchFormRef
          }, null, 512), _createVNode(_component_XFlexCtx, {
            flex: 1
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("div", {
                style: {
                  "height": "100%"
                },
                ref_key: "tableRef",
                ref: tableRef
              }, null, 512)];
            }),
            _: 1
          })])];
        }),
        _: 1
      }), _createElementVNode("div", {
        ref_key: "addRef",
        ref: addRef
      }, null, 512), _createElementVNode("div", {
        ref_key: "editRef",
        ref: editRef
      }, null, 512), _createElementVNode("div", {
        ref_key: "passwordRef",
        ref: passwordRef
      }, null, 512)]);
    };
  }
});